// Enter 상황에서 커서 앞 단어를 잘라오는 헬퍼
export const getWordBeforeCaret = (element: HTMLParagraphElement) => {
  if (typeof window === 'undefined') {
    return null;
  }

  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  const range = selection.getRangeAt(0);
  if (!element.contains(range.commonAncestorContainer)) {
    return null;
  }

  const beforeCaret = range.cloneRange();
  beforeCaret.selectNodeContents(element);
  beforeCaret.setEnd(range.endContainer, range.endOffset);

  const textBeforeCaret = beforeCaret.toString();
  if (!textBeforeCaret) {
    const afterCaret = range.cloneRange();
    afterCaret.selectNodeContents(element);
    afterCaret.setStart(range.endContainer, range.endOffset);

    const textAfterCaret = afterCaret.toString();
    if (!textAfterCaret) {
      return null;
    }

    return textAfterCaret;
  }

  return textBeforeCaret;
};

// 커서가 단어의 시작/끝 위치인지 확인하는 헬퍼
export const getCaretWordBoundary = (
  element: HTMLParagraphElement,
): { start: boolean; end: boolean } => {
  if (typeof window === 'undefined') {
    return { start: false, end: false };
  }

  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0 || !selection.isCollapsed) {
    return { start: false, end: false };
  }

  const range = selection.getRangeAt(0);
  if (!element.contains(range.commonAncestorContainer)) {
    return { start: false, end: false };
  }

  const beforeCaret = range.cloneRange();
  beforeCaret.selectNodeContents(element);
  beforeCaret.setEnd(range.endContainer, range.endOffset);

  const afterCaret = range.cloneRange();
  afterCaret.selectNodeContents(element);
  afterCaret.setStart(range.endContainer, range.endOffset);

  const textBeforeCaret = beforeCaret.toString();
  const textAfterCaret = afterCaret.toString();

  return {
    start: textBeforeCaret.trim().length === 0,
    end: textAfterCaret.trim().length === 0,
  };
};
